import type { FillPathway } from '../../contexts/fill';
import type { MedicationConfigOverride } from '../../hooks/use-config-api';
import { getMedicationNdc } from '../get-medication-ndc';

export const getMedicationSwitchConfig = (
    medConfig: MedicationConfigOverride,
    medication: Parameters<typeof getMedicationNdc>[0],
    pathway: FillPathway | null,
    subPathway: string | null = null
) => {
    const ndc = getMedicationNdc(medication);

    if (!ndc || !pathway) {
        return null;
    }

    const switchConfig = medConfig.ndcSwitchConfigsV2?.[ndc];

    if (!switchConfig) {
        return null;
    }

    const pathwaySwitchConfigs = switchConfig[pathway];

    if (!subPathway) {
        return pathwaySwitchConfigs?.[0] ?? null;
    }

    const subPathwaySpecificConfig = pathwaySwitchConfigs?.find((config) =>
        config?.subPathways?.includes(subPathway)
    );

    const allSubPathwaysConfig = pathwaySwitchConfigs?.find(
        (config) => (config?.subPathways ?? []).length === 0
    );

    return subPathwaySpecificConfig ?? allSubPathwaysConfig ?? null;
};
